export default function getAvatar(item = {}) {
  return item?.avatar ?? null
}
